export default __webpack_public_path__ + "static/media/gallery_06.24fc2c55.jpg";